import store from "@/store";
import enviroment from "@/assets/js/enviroment";

const auth = (to, from, next) => {
  const token = to.query.token;
  if (token) {
    store.dispatch("auth/auth", token)
      .then(() => next("/"))
      .catch((err) => {
        console.error(err);
        next("/error");
      });
  } else {
    window.location = enviroment.apiUrl + 'oauth/login';
  }
};

const checkAuth = async (to, from, next) => {
  document.title = (to.meta.title || "Asset") + " - Asset";

  if (to.meta.requiresAuth === false) {
    return next();
  }

  try {
    const isAuthenticated = await store.dispatch("auth/checkAuth");
    if (isAuthenticated) {
      next();
    } else {
      if (to.name === 'authenticate') return next();
      next({ name: "authenticate" });
    }
  } catch (err) {
    console.error(err);
    next("/error");
  }
};

export { auth, checkAuth };
